import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface UnsupportedPluginModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  types: string[]
}

export const UnsupportedPluginModal = ({ open, onOpenChange, types }: UnsupportedPluginModalProps) => {
  const { t } = useTranslation(['stores'])

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            {t('stores:productSync.unsupportedModalTitle')}
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3 text-left">
            <p>{t('stores:productSync.unsupportedModalBody')}</p>
            {types.length > 0 && (
              <div className="rounded-md bg-muted px-3 py-2">
                <p className="text-xs font-medium text-muted-foreground mb-1">
                  {t('stores:productSync.unsupportedModalTypesLabel')}
                </p>
                <ul className="list-disc list-inside text-sm font-mono">
                  {types.map((type) => (
                    <li key={type}>{type}</li>
                  ))}
                </ul>
              </div>
            )}
            <p className="text-sm text-muted-foreground">
              {t('stores:productSync.unsupportedModalHint')}
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => onOpenChange(false)}>
            {t('stores:productSync.unsupportedModalAck')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
